import {
  DOCUMENTATION_REQUEST,
  DOCUMENTATION_AVAILABLE,
  DOCUMENTATION_UNAVAILABLE,
  DOCUMENTATION_CREDENTIAL_REQUEST,
  DOCUMENTATION_CREDENTIAL_AVAILABLE,
  DOCUMENTATION_CREDENTIAL_UNAVAILABLE,
  SNACK_SET
} from './constants';
import { createReducer } from './utils';
import {
  handleRequest,
  handleAvailable,
  handleUnavailable,
} from '../reducerHandlers';

export const API_DOCS_TOKEN_KEY = 'apiDocsToken';

const defaultState = {
  loading: false,
  apiSpec: null,
  loadingApiSpec: false,
  errorMessage: null,
  credentialRequested: false,
  credentialLoading: false,
};

export const reducer = createReducer(defaultState, {
  [DOCUMENTATION_REQUEST]: handleRequest,
  [DOCUMENTATION_AVAILABLE]: handleAvailable,
  [DOCUMENTATION_UNAVAILABLE]: handleUnavailable,
  [DOCUMENTATION_CREDENTIAL_REQUEST]: handleRequest,
  [DOCUMENTATION_CREDENTIAL_AVAILABLE]: handleAvailable,
  [DOCUMENTATION_CREDENTIAL_UNAVAILABLE]: handleUnavailable,
});

export function getApiDocsSpec(client_id, t) {
  return async (dispatch, getState, { services: { dataSource } }) => {
    const loadingName = 'loadingApiSpec';
    const keyState = 'apiSpec';
    dispatch({ type: DOCUMENTATION_REQUEST, payload: { loadingName } });

    try {
      const spec = await dataSource.getApiDocsSpec(client_id);
      dispatch({
        type: DOCUMENTATION_AVAILABLE,
        payload: { keyState, data: spec, loadingName },
      });
    } catch (error) {
      console.log('getApiDocsSpec error: ', error);
      dispatch({
        type: DOCUMENTATION_UNAVAILABLE,
        payload: { keyState, loadingName, defaultState: null },
      });
      const snack = {
        open: true,
        message: t('cws_app.documentation.error_getting_api_docs', 'There was an error getting the API documentation.'),
        severity: 'error',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
    }
  };
}

export function requestApiDocsCredentials(username, password, t) {
  return async (dispatch, getState, { services: { dataSource } }) => {
    const loadingName = 'credentialLoading';
    const keyState = 'credentialRequested';
    dispatch({ type: DOCUMENTATION_CREDENTIAL_REQUEST, payload: { loadingName } });

    try {
      const response = await dataSource.postApiDocsAuth(username, password);
      if (!response || !response.token) {
        throw new Error('Missing token in response');
      }
      sessionStorage.setItem(API_DOCS_TOKEN_KEY, response.token);
      dispatch({
        type: DOCUMENTATION_CREDENTIAL_AVAILABLE,
        payload: { keyState, data: true, loadingName },
      });
    } catch (error) {
      console.log('requestApiDocsCredentials error: ', error);
      sessionStorage.removeItem(API_DOCS_TOKEN_KEY);
      dispatch({
        type: DOCUMENTATION_CREDENTIAL_UNAVAILABLE,
        payload: { keyState, loadingName, defaultState: false },
      });
      const snack = {
        open: true,
        message: t('cws_app.documentation.error_authenticating', 'Invalid credentials or could not authenticate against the API.'),
        severity: 'error',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
    }
  };
}
